<button  style="margin-left: 20px;margin-top: 10px;" class="btn btn-primary" (click)="masssending_click()" data-toggle="modal" data-target=".bd-example-modal-xl">
    群發設定
</button>

<!--
<input type="text" ngxDaterangepickerMd [(ngModel)]="selected2" [opens]="'right'"
  [ranges]="ranges" [alwaysShowCalendars]="true" (ngModelChange)="ngModelChange($event)"
  (change)="change($event)"  [ngModelOptions]="{standalone: true}">
-->
<r-table [data]="posts_input">
    <ng-template let-post #operation_dk>
        <span *ngIf="post.key=='media'">
            <audio *ngIf="posts[post.idx].media" [src]="posts[post.idx].media" controls style="width: 150px;">
                <h3>遇到不支援的瀏覽器會出現這行字</h3>
            </audio>
        </span>
        <span *ngIf="post.key=='video'">
            <video *ngIf="posts[post.idx].video" [src]="posts[post.idx].video" controls width="150">
                <h3>遇到不支援的瀏覽器會出現這行字</h3>
            </video>
        </span>
        <span *ngIf="post.key=='setting'">
            <a href="javascript:void(0)" title="設定"  (click)="setting_click(posts[post.idx].setting)" data-toggle="modal" data-target=".bd-example-modal-xl">
                <i style="margin: 0 10px 0 0;" class="fas fa-cog"></i>
            </a>
        </span>
    </ng-template>
    <ng-template let-post #operation_mb>
        <span *ngIf="post.key=='media'">
            <audio *ngIf="posts[post.idx].media" [src]="posts[post.idx].media" controls style="width: 150px;">
                <h3>遇到不支援的瀏覽器會出現這行字</h3>
            </audio>
        </span>
        <span *ngIf="post.key=='video'">
            <video *ngIf="posts[post.idx].video" [src]="posts[post.idx].video" controls width="150">
                <h3>遇到不支援的瀏覽器會出現這行字</h3>
            </video>
        </span>
        <span *ngIf="post.key=='setting'">
            <a href="javascript:void(0)" title="設定"  (click)="setting_click(posts[post.idx].setting)" data-toggle="modal" data-target=".bd-example-modal-xl">
                <i style="margin: 0 10px 0 0;" class="fas fa-cog"></i>
            </a>
        </span>
    </ng-template>
</r-table>
<app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
<div *ngIf="posts.length==0">無資料</div>
<div
    *ngIf="modal_action==1"
    class="modal fade bd-example-modal-xl" tabindex="-1"
    role="dialog"  data-keyboard="false" data-backdrop="static"
    aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
    style="max-height: 680px;overflow:auto;"
>
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
                男生設定
            </div>
            <div class = "card">
                <div class="card-header">篩選條件</div>
                <div class="card-body">
                    <label style="margin-left: 20px;">地點</label>
                    <select class="form-control" [(ngModel)]="item_setting.country" style="width: 160px;display: inline-block;">
                        <option *ngFor="let item of country_option" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <label style="margin-left: 20px;">開啟推播</label>
                    <select class="form-control" [(ngModel)]="item_setting.search_boy_enable_push_msg" style="width: 160px;display: inline-block;">
                        <option *ngFor="let item of push_option" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <label style="margin-left: 20px;">註冊時間</label>
                    <select class="form-control" [(ngModel)]="item_setting.search_boy_register" style="width: 160px;display: inline-block;">
                        <option *ngFor="let item of register_option" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <label style="margin-left: 20px;">曾經儲值</label>
                    <select class="form-control" [(ngModel)]="item_setting.search_boy_has_deposit" style="width: 120px;display: inline-block;">
                        <option *ngFor="let item of deposit_option" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <br>
                    <label style="margin-left: 20px;">曾經傳訊聊天</label>
                    <select class="form-control" [(ngModel)]="item_setting.search_boy_has_chat" style="width: 125px;display: inline-block;">
                        <option *ngFor="let item of chat_option" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <label *ngIf="item_setting.search_boy_has_chat=='1'" style="margin-left: 20px;">上次傳訊時間</label>
                    <select *ngIf="item_setting.search_boy_has_chat=='1'" class="form-control" [(ngModel)]="item_setting.search_boy_last_chat" style="width: 160px;display: inline-block;">
                        <option *ngFor="let item of chatdate_option" [ngValue]="item.id">{{item.name}}</option>
                    </select>

                    <label style="margin-left: 20px;">上次上線時間</label>
                    <select class="form-control" [(ngModel)]="item_setting.search_boy_last_login" style="width: 160px;display: inline-block;">
                        <option *ngFor="let item of login_option" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <div>
                        <input type="text" [(ngModel)]="item_setting.search" style="width: 400px;display:inline-block" class="form-control" placeholder="只送給特定男生姓名/電話(可輸入多人用,隔開)"  >
                    </div>
                </div>
            </div>
            <div class = "card">
                <div class="card-header">排除條件</div>
                <div class="card-body">
                    <!--
                    <label style="margin-left: 20px;">曾群發過</label>
                    <select class="form-control" [(ngModel)]="item_setting.search_boy_has_mass_send"
                      style="width: 160px;display: inline-block;" 
                      >
                      <option *ngFor="let item of sending_option" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <label style="margin-left: 20px;">跟發送的女生聊過</label>
                    <select class="form-control" [(ngModel)]="item_setting.search_boy_has_chat_the_girl"
                      style="width: 100px;display: inline-block;" 
                      >
                      <option *ngFor="let item of chat_option" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    -->
                    <div>
                        <input type="text" [(ngModel)]="item_setting.search_except" style="width: 400px;display:inline-block" class="form-control" placeholder="排除特定男生姓名/電話(可輸入多人用,隔開)"  >
                    </div>
                </div>
            </div>
        
            <!-- Modal footer -->
            <div class="modal-footer" >
                <button type="button"  class="btn btn-danger" data-dismiss="modal">取消</button>
            </div>
        </div>
    </div>
</div>
<div
    *ngIf="modal_action==0"
    class="modal fade bd-example-modal-xl" tabindex="-1"
    role="dialog"  data-keyboard="false" data-backdrop="static"
    aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
    style="max-height: 680px;overflow:auto;"
>
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header"></div>
            <!-- Modal body -->
            <mat-horizontal-stepper linear #stepper (selectionChange)="selectionChange($event)">
                <mat-step [stepControl]="zeroFormGroup" [editable]="isEditable">
                    <form [formGroup]="zeroFormGroup">
                        <div>
                            <ng-template matStepLabel>群發設定</ng-template>
                            <mat-form-field  style="width: 100%" appearance="fill">
                                <mat-label>群發訊息內容(當有上傳語音/影片時，以下訊息只會出現在推播中)</mat-label>
                                <input matInput [(ngModel)]="msg_content" formControlName="zeroCtrl" placeholder="群發訊息內容" required>
                            </mat-form-field>
                        </div>
                        <div *ngIf="upload_pic != null || upload_video_filename != null">
                            內容順序:
                            <select class="form-control" [(ngModel)]="execution" [ngModelOptions]="{standalone: true}" style="width: 160px;margin-left: 1%;display: inline-block;">
                                <option *ngFor="let item of execution_option" [ngValue]="item.id">{{item.name}}</option>
                            </select>
                        </div>
                        <br>
                        <div>
                            <div>
                                上傳圖片:
                                <img loading="lazy" style="height: 80px" [src]="upload_pic"  (click)="upload_pic=''">
                                <div class="btn btn-info" style="position:relative;margin-left:10px;">
                                    <input style="opacity:0;width:100%;height:100%;position:absolute;left:0;top:0;" type="file" (change)="upload($event)" placeholder="Upload file" accept=".jpeg,.jpg,.png,.gif">點我上傳
                                </div>
                                <input type="number"  *ngIf="upload_pic != null" [(ngModel)]="img_diamond" style="width: 160px;display: inline-block;margin-left: 2%;display:inline-block" class="form-control" placeholder="圖片鑽石數"   [ngModelOptions]="{standalone: true}">
                            </div>                    
                        </div>
                        <br>
                        <div>
                            <div>
                                上傳語音:
                                     <!--
                                     <audio *ngIf="upload_voice" [src]="upload_voice" controls>
                                       <h3>遇到不支援的瀏覽器會出現這行字</h3>
                                     </audio>
                                    -->
                                <div class="btn btn-info" style="position:relative;margin-left:10px;">
                                    <input style="opacity:0;width:100%;height:100%;position:absolute;left:0;top:0;" type="file" (change)="upload2($event)" placeholder="Upload file" accept=".wav">點我上傳
                                </div>
                                {{upload_voice_filename}}
                            </div>
                        </div>
                        <br>
                        <div>
                            <div>
                                上傳影片:
                                <video *ngIf="upload_video" [src]="upload_video" controls width="250">
                                    <h3>遇到不支援的瀏覽器會出現這行字</h3>
                                </video>
                                <div class="btn btn-info" style="position:relative;margin-left:10px;">
                                    <input style="opacity:0;width:100%;height:100%;position:absolute;left:0;top:0;" type="file" (change)="upload3($event)" placeholder="Upload file" accept=".mp4">點我上傳
                                </div>
                                {{upload_video_filename}}
                                <input type="number" *ngIf="upload_video_filename != null" [(ngModel)]="video_diamond" style="width: 160px;display: inline-block;margin-left: 2%;display:inline-block" class="form-control" placeholder="影片鑽石數"   [ngModelOptions]="{standalone: true}">
                            </div>
                        </div>
                        <div>
                            <button mat-button matStepperNext>下一步</button>
                        </div>
                    </form>
                </mat-step>
                <mat-step [stepControl]="firstFormGroup" [editable]="isEditable">
                    <form [formGroup]="firstFormGroup">
                        <ng-template matStepLabel>選擇女生</ng-template>
                        <input  type="text" [(ngModel)]="search_model" style="width: 200px;display:inline-block" class="form-control" placeholder="請輸入姓名或手機搜尋"   [ngModelOptions]="{standalone: true}">
                        <button type="button"  (click)="init_girl_list()" class="btn btn-primary" >確定</button>
                        <table style="margin-top: 10px;"  class="table table-responsive-sm" >
                            <thead>
                                <tr class="table-primary" style="font-size:18px;">
                                    <th>姓名</th>
                                    <th>大頭貼</th>
                                    <th>提領金額</th>
                                    <th >收鑽</th>
                                    <th >通話時長</th>
                                    <th >通話率</th>
                                    <th >拒接率</th>
                                    <th >訊息(送)</th>
                                    <th >訊息(收)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of girl_data; let i = index; trackBy: trackByFn" (click)="girlrowclick(item)" class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                                    <td *ngIf="selected_girl.id===item.id" bgcolor="yellow">
                                        <span >{{item.name}}
                                            <div *ngIf="item.v_name && item.v_name.length>0">({{item.v_name}})</div>
                                        </span>
                                    </td>
                                    <td *ngIf="selected_girl.id!==item.id">
                                        <span >{{item.name}}
                                            <div *ngIf="item.v_name && item.v_name.length>0">({{item.v_name}})</div>
                                        </span>
                                    </td>
                                    <td><img loading="lazy" style="width: 50px" src="{{item.profile_pic}}"></td>
                                    <td>{{item.money|number}}</td>
                                    <td>{{item.diamond|number}}</td>
                                    <td>{{item.tel_time}}</td>
                                    <td>{{item.tel_rate}}</td>
                                    <td>{{item.reject_rate}}</td>
                                    <td>{{item.send_chats_num}}</td>
                                    <td>{{item.receve_chats_num}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <app-pagnation (callback)="callback1($event)" [data]="girl_pageobjstr"></app-pagnation> 
                        <div *ngIf="girl_data.length==0">無資料</div> 
                        <mat-form-field style="float:right;margin-top: -30px;" appearance="fill">
                            <mat-label>已選擇女生</mat-label>
                            <input matInput formControlName="firstCtrl" [(ngModel)]="selected_girl.name"  placeholder="點下方表格選擇女生" required readonly>
                        </mat-form-field> 
                        <div>
                            <button mat-button matStepperPrevious>上一步</button>
                            <button mat-button matStepperNext>下一步</button>
                        </div>
                    </form>
                </mat-step>
                <mat-step [stepControl]="secondFormGroup" [editable]="isEditable">
                    <form [formGroup]="secondFormGroup">
                        <ng-template matStepLabel>選擇男生</ng-template>
                        <div class = "card">
                            <div class="card-header">篩選條件</div>
                            <div class="card-body">
                                <label style="margin-left: 20px;">地點</label>
                                <select class="form-control" [(ngModel)]="search_boy_country" [ngModelOptions]="{standalone: true}" style="width: 160px;display: inline-block;" (change)="init_boy_list()">
                                    <option *ngFor="let item of country_option" [ngValue]="item.id">{{item.name}}</option>
                                </select>
                            
                                <label style="margin-left: 20px;">開啟推播</label>
                                <select class="form-control" [(ngModel)]="search_boy_enable_push_msg" [ngModelOptions]="{standalone: true}" style="width: 160px;display: inline-block;" (change)="init_boy_list()">
                                    <option *ngFor="let item of push_option" [ngValue]="item.id">{{item.name}}</option>
                                </select>
                                <label style="margin-left: 20px;">註冊時間</label>
                                <select class="form-control" [(ngModel)]="search_boy_register" [ngModelOptions]="{standalone: true}" style="width: 160px;display: inline-block;" (change)="init_boy_list()">
                                    <option *ngFor="let item of register_option" [ngValue]="item.id">{{item.name}}</option>
                                </select>
                                <label style="margin-left: 20px;">曾經儲值</label>
                                <select class="form-control" [(ngModel)]="search_boy_has_deposit" [ngModelOptions]="{standalone: true}" style="width: 120px;display: inline-block;" (change)="init_boy_list()">
                                    <option *ngFor="let item of deposit_option" [ngValue]="item.id">{{item.name}}</option>
                                </select>
                                <br>
                                <label style="margin-left: 20px;">曾經傳訊聊天</label>
                                <select class="form-control" [(ngModel)]="search_boy_has_chat" [ngModelOptions]="{standalone: true}" style="width: 125px;display: inline-block;" (change)="init_boy_list()">
                                    <option *ngFor="let item of chat_option" [ngValue]="item.id">{{item.name}}</option>
                                </select>
                                <label *ngIf="search_boy_has_chat=='1'" style="margin-left: 20px;">上次傳訊時間</label>
                                <select *ngIf="search_boy_has_chat=='1'" class="form-control" [(ngModel)]="search_boy_last_chat" [ngModelOptions]="{standalone: true}" style="width: 160px;display: inline-block;" (change)="init_boy_list()">
                                    <option *ngFor="let item of chatdate_option" [ngValue]="item.id">{{item.name}}</option>
                                </select>
                                <label style="margin-left: 20px;">上次上線時間</label>
                                <select class="form-control" [(ngModel)]="search_boy_last_login" [ngModelOptions]="{standalone: true}" style="width: 160px;display: inline-block;" (change)="init_boy_list()">
                                    <option *ngFor="let item of login_option" [ngValue]="item.id">{{item.name}}</option>
                                </select>
                                <div>
                                    <input type="text" [(ngModel)]="search_boy_model" style="width: 400px;display:inline-block" class="form-control" placeholder="只送給特定男生姓名/電話(可輸入多人用,隔開)"   [ngModelOptions]="{standalone: true}">
                                    <button type="button"  (click)="init_boy_list()" class="btn btn-primary" >確定</button>
                                </div>
                            </div>
                        </div>
                        <div class = "card">
                            <div class="card-header">排除條件</div>
                            <div class="card-body">
                                <!--
                                <label style="margin-left: 20px;">曾群發過</label>
                                <select class="form-control" [(ngModel)]="search_boy_has_mass_send" [ngModelOptions]="{standalone: true}"
                                  style="width: 160px;display: inline-block;" (change)="init_boy_list()"
                                  >
                                  <option *ngFor="let item of sending_option" [ngValue]="item.id">{{item.name}}</option>
                                </select>
                                <label style="margin-left: 20px;">跟發送的女生聊過</label>
                                <select class="form-control" [(ngModel)]="search_boy_has_chat_the_girl" [ngModelOptions]="{standalone: true}"
                                  style="width: 100px;display: inline-block;" (change)="init_boy_list()"
                                  >
                                  <option *ngFor="let item of chat_option" [ngValue]="item.id">{{item.name}}</option>
                                </select>
                                -->
                                <div>
                                    <input type="text" [(ngModel)]="search_boy_except_model" style="width: 400px;display:inline-block" class="form-control" placeholder="排除特定男生姓名/電話(可輸入多人用,隔開)"   [ngModelOptions]="{standalone: true}">
                                    <button type="button" (click)="init_boy_list()" class="btn  btn-primary" >確定</button>
                                </div>
                            </div>
                        </div>
                    
                        <mat-form-field  style="float:right;" appearance="fill">
                            <mat-label>男生符合人數</mat-label>
                            <input matInput formControlName="secondCtrl" [(ngModel)]="selected_boy"  placeholder="點選篩選器搜尋適合男生" required readonly>
                        </mat-form-field>
                        <div>
                            封鎖女生人數: {{block_count}}
                            &nbsp;&nbsp;，封鎖率: {{selected_boy>0?(100*block_count/selected_boy).toFixed(2):0}} %
                        </div>
                        <button mat-button (click)="expand_boy_list = !expand_boy_list" style="float:right;">{{expand_boy_list?'隱藏列表':'展開列表'}}</button>
                        <div>
                            <button mat-button matStepperPrevious>上一步</button>
                            <button mat-button matStepperNext>下一步</button>
                        </div>
                        <div *ngIf="expand_boy_list">
                            <input type="text" [(ngModel)]="search_boy_list" style="width: 300px;display:inline-block" class="form-control" placeholder="搜尋男生姓名/電話"   [ngModelOptions]="{standalone: true}">
                            <button type="button" (click)="init_boy_list(true)" class="btn  btn-primary" >確定</button>
                            <table style="margin-top: 10px;"  class="table table-responsive-sm" >
                                <thead>
                                    <tr class="table-primary" style="font-size:18px;">
                                        <th>姓名</th>
                                        <th>大頭貼</th>
                                        <th>儲值金額</th>
                                        <th >花鑽</th>
                                        <th >通話時長</th>
                                        <th >通話率</th>
                                        <th >拒接率</th>
                                        <th >訊息(送)</th>
                                        <th >訊息(收)</th>
                                        <th >封鎖女生</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of boy_data_tmp; let i = index; trackBy: trackByFn"  class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                                        <td>{{item.name}}</td>
                                        <td><img loading="lazy" style="width: 50px" src="{{item.profile_pic}}"></td>
                                        <td>{{item.money|number}}</td>
                                        <td>{{item.diamond|number}}</td>
                                        <td>{{item.tel_time}}</td>
                                        <td>{{item.tel_rate}}</td>
                                        <td>{{item.reject_rate}}</td>
                                        <td>{{item.send_chats_num}}</td>
                                        <td>{{item.receve_chats_num}}</td>
                                        <td>{{item.block_the_girl?'是':'否'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <app-pagnation (callback)="callback2($event)" [data]="boy_pageobjstr"></app-pagnation> 
                            <div *ngIf="boy_data.length==0">無資料</div>
                        </div>
                    </form>
                </mat-step>
                <mat-step>
                    <ng-template matStepLabel>確認</ng-template>
                    <p></p>
                    <div>
                        發送女生: {{selected_girl.name}}
                    </div>
                    <div>
                        男生總人數: {{selected_boy}} 
                        &nbsp;&nbsp;，封鎖女生人數: {{block_count}}
                        &nbsp;&nbsp;，封鎖率: {{selected_boy>0?(100*block_count/selected_boy).toFixed(2):0}} %
                    </div>
                    <div>
                        預計發送則數: <input type="text" [(ngModel)]="msg_amount" style="width: 100px;display:inline-block" class="form-control" placeholder="預計發送則數"   [ngModelOptions]="{standalone: true}">
                    </div>
                    <div>
                        發送內容: {{msg_content}}
                    </div>
                    <div>
                        發送圖片/語音/影片: 
                        <img loading="lazy" style="height: 80px" [src]="upload_pic" >
                        <br>
                        {{upload_voice_filename}}
                        <br>
                        {{upload_video_filename}}
                        <!--
                        <audio *ngIf="upload_voice" [src]="upload_voice" controls>
                          <h3>遇到不支援的瀏覽器會出現這行字</h3>
                        </audio>
                        -->
                    </div>
                    <div>
                        <label for="datetime">選擇發送時間:</label>
                        <input type="datetime-local" id="datetime" name="datetime"  [(ngModel)]="selectedDateTime" required>
                    </div>
                    <br><br>
                    <div>
                        <button mat-button matStepperPrevious>上一步</button>
                        <button mat-button (click)="set_mass_sending()" >確認送出</button>
                    </div>
                </mat-step>
            </mat-horizontal-stepper>
            <!-- Modal footer -->
            <div class="modal-footer" >
                <button #closeModal type="button"  class="btn btn-danger" data-dismiss="modal">取消</button>
            </div>
        </div>
    </div>
</div>

<app-spinner [loading]="loading"></app-spinner>
